module.exports = __webpack_public_path__ + "static/media/eco-ecology-grass-svgrepo-com.9220aab0.svg";